<div class="flex flex-col gap-6 py-8" *transloco="let t">
  <h4>{{ t("common.budget") }}</h4>

  @if (isAwareness()) {
    <IFormField class="w-full">
      <label iLabel>{{ t("common.budget") }}</label>
      <div iInputGroup class="w-full">
        <input
          iInputGroupInput
          type="number"
          [formField]="budget().budget"
          size="sm"
          [placeholder]="t('common.budget')"
        />
        @if (currencyCode(); as currency) {
          <span class="text-muted-foreground" iInputGroupSuffix>
            <app-budget-currency-badge [budgetCurrency]="currency" [amount]="budget().budget().value()" />
          </span>
        }
      </div>
      <IError>{{ t("dsp-create-strategy-page.budget_must_be_greater_than_1") }}</IError>
      @if (maxImpressions(); as impressions) {
        <span class="type-caption text-muted-foreground">
          {{
            t("dsp-media-selector.max_impressions", {
              impressions: impressions | number: "1.0-0" : locale(),
            })
          }}
        </span>
      }
    </IFormField>

    <IFormField class="w-full">
      <label iLabel>{{ t("common.date") }}</label>
      <IDatePicker
        class="w-full"
        [dateFormat]="dateFormat()"
        [minDate]="today"
        [maxDate]="nextYear"
        [withShortcuts]="false"
        [disabled]="budget().budgetDates().disabled()"
        placement="bottom"
        [selectedDateRange]="budget().budgetDates().value() ?? null"
        (selectedDateRangeChange)="selectBudgetDates($event)"
      />
      @if (budget().budgetDates().dirty() && budget().budgetDates().invalid()) {
        @for (error of budget().budgetDates().errors(); track error.kind) {
          <IError>{{ t(error.message!) }}</IError>
        }
      }
    </IFormField>
  } @else {
    <IFormField class="w-full">
      <label iLabel>{{ t("common.monthly_budget") }}</label>
      <div iInputGroup class="w-full">
        <input
          iInputGroupInput
          type="number"
          [formField]="budget().monthlyBudget"
          size="sm"
          [placeholder]="t('common.monthly_budget')"
        />
        @if (currencyCode(); as currency) {
          <span class="text-muted-foreground" iInputGroupSuffix>
            <app-budget-currency-badge [budgetCurrency]="currency" [amount]="budget().monthlyBudget().value()" />
          </span>
        }
      </div>
      <IError>{{ t("dsp-create-strategy-page.budget_must_be_greater_than_1") }}</IError>
    </IFormField>
    @if (budget().monthlyBudget().value(); as monthlyBudget) {
      @if (monthlyBudget > 0 && currencyCode(); as currency) {
        <app-monthly-budget-warning [value]="monthlyBudget" [currencyCode]="currency" />
      }
    }
  }
</div>
